module.exports = __webpack_public_path__ + "img/blog-3.f4c21a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/blog-3.jpg
// module id = 1461
// module chunks = 1